var BlimpLocal = new Class({
	Extends: BlimpExt,

	build: function() {
		var url = this._link.get('data-rpc') || this._link.get('href');

		if(!url) {
			return;
		}

		var first_char = url.substring(0, 1);

		if (first_char == '#')
		{
			this.id = url.substring(1, url.length);

			this._link.addEvent('click', function(e) {
				if(e && e.stop)
					e.stop();
				this.fetch(this.id);
			}.bind(this));
			return true;
		}
		else {
			Log.log('Invalid href for local blimp');
			return false;
		}
	},

	fetch: function(id) {
		this._element = document.id(this.id);
		document.id(document.body).grab(this._element);
		this._element.removeClass('none');
		this.content = this._element;
		this.process();
		this.fireEvent('success');
	},

	toElement: function() {
		return document.id(this._element);
	},

	build_toggle: function() {
		return;
	},
});
